module.exports = __webpack_public_path__ + "static/media/girl_pointing_flower.eefd8139.gif";